export enum RequestType {
  TransferOut = 'TransferOut',
  TransferToCard = 'TransferToCard',
  Refill = 'Refill',
}
